import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="userinfo" id="userinfo"></a>
    <h1 {...{
      "id": "requireuxpuserinfo"
    }}>{`require('uxp').userInfo`}</h1>
    <p>{`Includes information about the user.`}</p>
    <p>{`Add the below permission in your plugin's  `}<inlineCode parentName="p">{`manifest.json`}</inlineCode>{` file to use this API.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`"requiredPermissions": {
  "enableUserInfo": true
}
`}</code></pre>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <a name="userinfo-userid" id="userinfo-userid"></a>
    <h2 {...{
      "id": "userid"
    }}>{`userId()`}</h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get the GUID of the plugin user`}</p>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.3.0`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`let userId = require('uxp').userInfo.userId(); // Get the GUID of plugin user
console.log(userId); // e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      